import { Box, styled } from '@mui/material';

export interface IconBoxProps {
  backGroundImg: String;
}

export const CoreBenefitCardStyled = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  minWidth: '293px',
  width: '293px',
  height: '433px',
  padding: '36px 20px 36px 20px',
  backgroundColor: ' #FFFFFF',
  borderRadius: '1.5rem',
  position: 'relative',
  gap: '12px',
  border: '1px solid #dee2e6 !important',
  '& .tooltip': {
    bottom: '92%',
  },
  '@media (min-width: 1200px)': {
    width: '333px',
  },
});

export const BenefitCardHeaderStyled = styled('div')({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
});

export const IconBoxStyled = styled('div')(
  ({ backGroundImg }: IconBoxProps) => ({
    width: '60px',
    height: '50px',
    backgroundRepeat: 'no-repeat',
    backgroundImage: `url(${backGroundImg})`,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  })
);

export const DeductibleSectionStyled = styled('div')({
  border: '1px solid #E6E6E6',
  borderRadius: '8px',
  padding: '18px',
  minHeight: '140px',
  width: '100%',
  '& div': {
    '& span': {
      display: 'block',
      fontSize: '14px',
      fontWeight: '500',
      letterSpacing: '.1px',
    },
  },
  '& .annualDetails': {
    fontWeight: '600',
    fontSize: '16px',
    lineHeight: '24px',
    textAlign: 'left',
  },

  '& .networkPill': {
    border: '1px solid #e6e6e6',
    borderRadius: '4px',
    backgroundColor: '#e6e6e6',
    padding: '0px 6px',
    width: 'fit-content',
    '& span': {
      fontFamily: 'Inter',
      fontSize: '12px',
      fontWeight: '400',
      textAlign: 'center',
      letterSpacing: '1.2px',
    },
  },
  '& span': {
    fontWeight: '600',
    fontSize: '14px',
    lineHeight: '24px',
    fontFamily: 'Inter',
    fontStyle: 'normal ',
    letterSpacing: '0.15px',
  },
});

export const AvatarSectionWrapper = styled('div')({
  display: 'flex',
  gap: '16px',
});

export const CarrierBoxStyled = styled(Box)({
  display: 'flex',
  flexFlow: 'column',
  justifyContent: 'center',
  alignItems: 'flex-end',
  flex: 0.9,
  overflow: 'hidden',
});

export const CarrierLogoBoxStyled = styled(Box)({
  display: 'flex',
  alignItems: 'right',
  marginLeft: 'auto',
  gap: '4px',
});

export const CarrierImageStyled = styled('img')({
  height: '24px',
  maxWidth: '115px',
  display: 'block',
  margin: 'auto',
});

export const BenefitPlanNameStyled = styled('h3')({
  fontFamily: 'Inter',
  fontSize: '19px',
  fontStyle: 'normal',
  fontWeight: '600',
  letterSpacing: '0.15px',
  textAlign: 'right',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  maxWidth: '100%',
  marginBottom: '0 !important',
});
export const TruncatedBenefitPlanNameStyled = styled('button')({
  fontFamily: 'Inter',
  fontSize: '19px',
  fontStyle: 'normal',
  fontWeight: '600',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  width: '100%',
  maxWidth: '100%',
  backgroundColor: 'inherit',
  paddingLeft: '16px',
});

export const CarrierNameStyled = styled('button')({
  whiteSpace: 'noWrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  maxWidth: '12ch',
  color: '#56638a',
  backgroundColor: 'inherit',
});

export const AvatarBoxStyled = styled(Box)({
  display: 'flex',
  flexFlow: 'column',
  alignItems: 'center',
  gap: '8px',
  minWidth: '60px',
});
